// extracted by mini-css-extract-plugin
module.exports = {"root":"intro_root__32LGj","outer":"intro_outer__3CETG","inner":"intro_inner__2Vf16","priceCard":"intro_priceCard__r1qik","priceCardBody":"intro_priceCardBody__1zwVQ"};